<template>
	<page-container :page="page">
		<heading-image
			v-if="page.headingImage"
			:heading-image="{
				image: page.headingImage,
				imageWebp: page.headingImageWebp,
				imagePortrait: page.headingImagePortrait,
				imagePortraitWebp: page.headingImagePortraitWebp,
			}"
		/>

		<client-only>
			<component :is="'script'">
				(function (d, s, id, h) { var ftjs = d.getElementsByTagName(s)[0]; if (d.getElementById(id)) return; var
				js = d.createElement(s); js.id = id; js.src = 'https://cdn.formitable.com/sdk/v1/ft.sdk.min.js'; h &&
				(js.onload = h); ftjs.parentNode.insertBefore(js, ftjs); })(document, 'script', 'formitable-sdk',
				function () { FT.load('Analytics'); });
			</component>
			<div
				class="ft-widget-b2"
				data-group="f4708952"
				data-open="1500"
				data-open-mobile="false"
				data-color="#000000"
				:data-language="locale"
				data-tag="Website"
				data-toolbar="true"
				data-toolbar-mobile="true"
			></div>
		</client-only>

		<main-content
			v-if="!page.introblock"
			:title="page.title || page.header"
			:content="page.content"
			:intro-image="{ image: page.introductionImage, imageWebp: page.introductionImageWebp }"
		/>

		<intro-block v-if="page.introblock" :item="page.introblock" />

		<contentblocks :items="page.contentblocks" />

		<usp-block v-if="page.uSPBlock" :header="page.uSPBlock.header" :items="page.uSPBlock.items" />

		<frequently-asked-questions
			v-if="page.frequentlyAskedQuestion"
			:items="page.frequentlyAskedQuestion.faqitems"
			:header="page.frequentlyAskedQuestion.header"
		/>
	</page-container>
</template>

<script setup>
const { locale } = useI18n();
const { page, fetchPage } = usePage();

await fetchPage();

onMounted(() => {
	if (window.FT && window.FT.widgets?.current?.parse) {
		window.FT.widgets.current.parse();
	}
});
</script>
